import { IncError } from "@core/domain/errors/inc.error";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { ValidationError } from "@core/domain/errors/validation.error";
import i18n from "@i18n";

export class DuplicateBudgetTemplateNameError extends IncError {
    constructor() {
        super(i18n.t("error:project.budgetTemplate.duplicateName"));
        Object.setPrototypeOf(this, DuplicateBudgetTemplateNameError.prototype);
    }
}

// Map low-level errors to domain-specific, translated errors for budget templates
export function mapBudgetTemplateError(
    err: ValidationError | FallbackError,
): IncError {
    if (err instanceof ValidationError) {
        // Access runtime field (TS private) without modifying core API
        const raw = (err as unknown as { errors?: Record<string, string[]> }).errors;
        const nameErrors = raw?.["name"];
        if (nameErrors && nameErrors.length) return new DuplicateBudgetTemplateNameError();
    }
    return err;
}
